import { combineReducers } from "redux";
import { AppReducer, AppConstant } from "./AppReducer";
import { AuthReducer, AuthConstant } from "./AuthReducer";
import { AvatarReducer, AvatarConstant } from "./AvatarReducer";


const appReducer = combineReducers({
	AppReducer,
	AuthReducer,
	AvatarReducer,
});

const RootReducer = (state, action) => {
	return appReducer(state, action)
}

export default RootReducer;
export {
	AppConstant,
	AuthConstant,
	AvatarConstant,
};